import * as immer from "immer";
import { useImmer } from "use-immer";

immer.enableMapSet();

/** Wrapper module around {@link immer} that enables {@link Map} and {@link Set} functionality */
export * from "immer";
export { useImmer };
